import Immutable, { Map, List } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// action types
export const SET_ACTIVE_SISENSE_TAB = 'sisense/SET_ACTIVE_SISENSE_TAB'
export const SISENSE_CLEAR_DATA = 'sisense/SISENSE_CLEAR_DATA'
export const SISENSE_FETCH_LIST_BY_APPLICATION =
  'sisense/SISENSE_FETCH_LIST_BY_APPLICATION'
export const [
  SISENSE_FETCH_LIST_BY_APPLICATION_SUCCESS,
  SISENSE_FETCH_LIST_BY_APPLICATION_FAILURE,
] = [
  `${SISENSE_FETCH_LIST_BY_APPLICATION}_SUCCESS`,
  `${SISENSE_FETCH_LIST_BY_APPLICATION}_FAILURE`,
]
export const SISENSE_FETCH_TABLE_DATA = 'sisense/SISENSE_FETCH_TABLE_DATA'
export const [
  SISENSE_FETCH_TABLE_DATA_SUCCESS,
  SISENSE_FETCH_TABLE_DATA_FAILURE,
] = [
  `${SISENSE_FETCH_TABLE_DATA}_SUCCESS`,
  `${SISENSE_FETCH_TABLE_DATA}_FAILURE`,
]
export const SISENSE_DELETE = 'sisense/DELETE'
export const [SISENSE_DELETE_SUCCESS, SISENSE_DELETE_FAILURE] = [
  `${SISENSE_DELETE}_SUCCESS`,
  `${SISENSE_DELETE}_FAILURE`,
]
export const SISENSE_CLEAR_STATE_LIST = 'sisense/SISENSE_CLEAR_STATE_LIST'
export const SISENSE_CLEAR_STATE_FORM = 'sisense/SISENSE_CLEAR_STATE_FORM'
export const SISENSE_CLEAR_STATE = 'sisense/CLEAR_STATE'
export const SISENSE_CHANGE = 'sisense/SISENSE_CHANGE'
export const LOAD_SISENSE_FORM = 'sisense/LOAD_SISENSE_FORM'
export const SISENSE_FETCH_FORM_DATA = 'sisense/SISENSE_FETCH_FORM_DATA'
export const [
  SISENSE_FETCH_FORM_DATA_SUCCESS,
  SISENSE_FETCH_FORM_DATA_FAILURE,
] = [`${SISENSE_FETCH_FORM_DATA}_SUCCESS`, `${SISENSE_FETCH_FORM_DATA}_FAILURE`]

// actions
export const setActiveSisenseData = ActionHelper.createActionObj(
  SET_ACTIVE_SISENSE_TAB,
)
export const sisenseFetchListByApplication = ActionHelper.createActionObj(
  SISENSE_FETCH_LIST_BY_APPLICATION,
)
export const sisenseClearData = ActionHelper.createActionObj(SISENSE_CLEAR_DATA)
export const sisenseFetchTableData = ActionHelper.createActionObj(
  SISENSE_FETCH_TABLE_DATA,
)
export const sisenseFetchFormData = ActionHelper.createActionObj(
  SISENSE_FETCH_FORM_DATA,
)
export const sisenseClearStateList = ActionHelper.createActionObj(
  SISENSE_CLEAR_STATE_LIST,
)
export const sisenseDelete = ActionHelper.createActionObj(SISENSE_DELETE)
export const sisenseClearState = ActionHelper.createActionObj(
  SISENSE_CLEAR_STATE,
)
export const sisenseClearStateForm = ActionHelper.createActionObj(
  SISENSE_CLEAR_STATE_FORM,
)
export const sisenseChange = ActionHelper.createActionObj(SISENSE_CHANGE)

const initialState = Immutable.fromJS({
  embedLink: '',
  refreshTriggerInterval: null,
  slug: '',
  id: 0,
  sisenseLoader: true,
  sisenseList: [],
  isLoadForm: false,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    sisense: {},
    applications: [],
  },
})
const loadingActive = state => state.set('loading', true)

const sisense = handleActions(
  {
    [combineActions(
      SISENSE_DELETE,
      SISENSE_FETCH_TABLE_DATA_SUCCESS,
      SISENSE_CHANGE,
    )]: loadingActive,
    [combineActions(SISENSE_CLEAR_STATE, RESET_STORE)]: () => initialState,
    [SET_ACTIVE_SISENSE_TAB]: (state, action) =>
      state
        .set('embedLink', action.payload.embedLink)
        .set('refreshTriggerInterval', action.payload.refreshTriggerInterval)
        .set('id', action.payload.id),
    [SISENSE_FETCH_LIST_BY_APPLICATION_SUCCESS]: (state, action) =>
      state.set('sisenseList', List(action.payload)),
    [SISENSE_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [LOAD_SISENSE_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [SISENSE_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [SISENSE_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [SISENSE_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [SISENSE_CLEAR_DATA]: () => initialState,
  },
  initialState,
)

export default sisense
